module.exports = {"Type":"DateTimeClassifier","Disabled":true,"Fields":[{"name":"lun_f1"},{"name":"lun_f2"},{"name":"lun_f3"},{"name":"mar_f1"},{"name":"mar_f2"},{"name":"mar_f3"},{"name":"mer_f1"},{"name":"mer_f2"},{"name":"mer_f3"},{"name":"gio_f1"},{"name":"gio_f2"},{"name":"gio_f3"},{"name":"ven_f1"},{"name":"ven_f2"},{"name":"ven_f3"},{"name":"sab_f1"},{"name":"sab_f2"},{"name":"sab_f3"},{"name":"dom_f1"},{"name":"dom_f2"},{"name":"dom_f3"},{"label":"Telemetry Id","name":"telemetryid"}],"Header":{"Color":"white","BackgroundColor":"#EE1010","Text":"DATETIMECLASSIFIER"}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/DateTimeClassifier.json
// module id = 659
// module chunks = 0